import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Grid,
  Divider,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../api/api";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const View = ({
  banners,
  setOption,
  setSelectedBanner,
  handleDeleteBanner,
}) => {
  const [selectedBannerId, setSelectedBannerId] = useState(null);

  return (
    <Box sx={{ py: 4 }}>
      <Box display="flex" justifyContent="flex-end" mb={3}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOption("create")}
        >
          <AddIcon />
          Criar Novo Banner
        </Button>
      </Box>

      <Grid container spacing={{ xs: 1, md: 4 }}>
        {banners.map((banner) => (
          <Grid item xs={12} sm={6} key={banner.id}>
            <Banner
              key={banner.id}
              banner={banner}
              setSelectedBannerId={setSelectedBannerId}
              setSelectedBanner={setSelectedBanner}
              isSelected={selectedBannerId === banner.id}
              setOption={setOption}
              handleDeleteBanner={handleDeleteBanner}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default View;

const Banner = ({
  banner,
  setSelectedBannerId,
  isSelected,
  setSelectedBanner,
  setOption,
  handleDeleteBanner,
}) => {
  const { id, name, text, href, imgUrl, imgUrlMobile } = banner;
  const b = banner;

  const renderStandardBanner = () => (
    <Card elevation={isSelected ? 6 : 2} className="h-full flex flex-col">
      <CardContent className="flex-1 flex flex-col">
        <Box display="flex" flexDirection="column" gap={2} className="flex-1">
          <Box
            display="flex"
            justifyContent="space-between"
            gap={2}
            sx={{ flexDirection: { xs: "column", md: "row" } }}
          >
            <Box className="flex flex-col md:flex-1">
              <Typography variant="h6" mb={1}>
                {name}
              </Typography>
              <Box display="flex" flexDirection="column" gap={1}>
                <Typography variant="body2">
                  <strong>Link:</strong> {href}
                </Typography>
                <Typography variant="body2">
                  <strong>Descrição:</strong> {text}
                </Typography>
              </Box>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              gap={1}
              className="flex-shrink-0"
            >
              <button
                onClick={() => handleDeleteBanner(id)}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-700 transition-colors flex items-center gap-2"
              >
                <DeleteIcon sx={{ fontSize: 16 }} />
                Deletar Card
              </button>
              <button
                onClick={() => {
                  setSelectedBannerId(id);
                  setSelectedBanner(b);
                  setOption("edit");
                }}
                className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-700 transition-colors flex items-center gap-2"
              >
                <EditIcon sx={{ fontSize: 16 }} />
                Editar Card
              </button>
            </Box>
          </Box>
          <div className="flex justify-center m-2 flex-col md:flex-row gap-3 p-5 flex-1">
            <div className="flex-1">
              <p className="text-sm bg-red-500 text-white mb-2 text-center p-3 rounded-lg">
                Imagem Desktop
              </p>
              <div className="overflow-hidden">
                <img
                  title="Imagem Desktop"
                  src={imgUrl}
                  alt={name}
                  className="w-64 h-full object-cover mx-auto my-auto rounded-lg"
                />
              </div>
            </div>
            {imgUrlMobile && (
              <div className="flex-1">
                <p className="text-sm bg-blue-500 text-white mb-2 text-center p-3 rounded-lg">
                  Imagem Mobile
                </p>
                <div className="overflow-hidden">
                  <img
                    title="Imagem Mobile"
                    src={imgUrlMobile}
                    alt={name}
                    className="w-64 h-full object-cover mx-auto my-auto rounded-lg"
                  />
                </div>
              </div>
            )}
          </div>
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <div className={` max-w-4xl mx-auto my-3  rounded-lg shadow-lg `}>
      {renderStandardBanner()}
    </div>
  );
};
